import { ReceptionServiceTableBean } from '../../../../../receptionService/extensions/calendar/appointment/interactiveTable/ReceptionServiceInteractiveTable.types';
import { appointmentsTranslationKeys } from '../../../../../translations';

export const getWarningMessage = (
   receptionServiceValue: ReceptionServiceTableBean[],
   videoConsultationCheckboxValue: boolean | undefined
): string | undefined => {
   if (receptionServiceValue.length === 0) {
      return undefined;
   }

   const allReceptionServicesAsVideoConsultation = receptionServiceValue.every(
      ({ receptionService }) => receptionService.deliveryMode === 'VIDEO_CONSULTATION'
   );
   const allReceptionServicesAsOnSite = receptionServiceValue.every(
      ({ receptionService }) => receptionService.deliveryMode === 'ON_SITE'
   );

   if (allReceptionServicesAsVideoConsultation && videoConsultationCheckboxValue) {
      return undefined;
   }

   if (allReceptionServicesAsVideoConsultation && !videoConsultationCheckboxValue) {
      return appointmentsTranslationKeys.videoConsultationWarning.allVideoConsultationReceptionServices;
   }

   if (allReceptionServicesAsOnSite && !videoConsultationCheckboxValue) {
      return undefined;
   }

   if (allReceptionServicesAsOnSite && videoConsultationCheckboxValue) {
      return appointmentsTranslationKeys.videoConsultationWarning.allOnSiteReceptionServices;
   }

   return appointmentsTranslationKeys.videoConsultationWarning.mixedDeliveryModeTypes;
};
